// extracted by mini-css-extract-plugin
export var content = "_HXBd6n6bloCQxwkZd5i";
export var info = "kNsN2gsdb69pqlWceVEM";
export var link = "SmXaa5c3t5C8VXAkR0qN";
export var negative = "W8BcbaPtIH5pCJSvDK_h";
export var neutral = "mP4mowENmCTnjzEI7g7w";
export var positive = "PWSkm8j54m3KliMh69sG";
export var primary = "O3XTGZncv8yDlkE9TfxX";
export var root = "kPnfT1ihLdjxqJYwrxRO";
export var secondary = "yEsLtGUJtOgsPq_L2a2b";
export var sideItem = "AR3Fxgpub9vOmktRNbYd";
export var warning = "k0D1DubE_KzEgsR9rcDb";